// @ts-nocheck
class OurCupcakes extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.domParser = new DOMParser();
    const now = new Date();
    this.maxItemsToShow = 8;
    this.loadedTabs = new Set(); // Track which tabs have been loaded
    this.noAddToCart = this.dataset.noAddToCart === 'true';
    
    // Get current date data
    this.currentMonth = now.toLocaleDateString('en-GB', { 
      month: 'long' 
    });
    
    // Month names for seasonal sorting
    this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.currentMonthIndex = now.getMonth(); // 0-11

    this.currentDay = now.toLocaleDateString('en-GB', { 
      weekday: 'long'
    });

    // Get all tabs
    this.tabs = this.querySelectorAll('.collection-tabs__tab');
    this.navItems = this.querySelectorAll('.collection-tabs__nav-item');
    
    // Setup tab navigation if multiple tabs exist
    if (this.navItems.length > 1) {
      this.setupTabNavigation();
    }

    // Initialize each tab
    this.tabs.forEach((tab, tabIndex) => {
      const collectionHandle = tab.dataset.collectionHandle;
      const isOneBlock = tab.dataset.oneBlock === 'true';
      const tabNumber = tabIndex + 1;
      
      // Find all blocks (1, 2, 3) within this tab
      for (let i = 1; i <= 3; i++) {
        const block = tab.querySelector(`#ResultsList${i}-tab-${tabNumber}`);
        const showMoreBtn = tab.querySelector(`#ShowMoreBtn${i}-tab-${tabNumber}`);
        const showMoreContainer = tab.querySelector(`#ShowMoreContainer${i}-tab-${tabNumber}`);
        
        if (block) {
          if (!this.blocks) this.blocks = [];
          this.blocks.push({
            element: block,
            showMoreBtn,
            showMoreContainer,
            collectionHandle,
            blockType: i,
            tabIndex: tabNumber,
            isOneBlock: isOneBlock
          });
          
          // Setup show more button
          if (showMoreBtn) {
            showMoreBtn.addEventListener('click', () => {
              this.showMoreItems(block, showMoreContainer);
            });
          }
        }
      }
    });

    // Get filter inputs (including mobile drawer filters if they exist)
    this.filterInputs = this.querySelectorAll('.our-cupcakes__filters [type="checkbox"], .facets--drawer [type="checkbox"]');
    
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateClearButtons();
        this.updateAllLists();
      });
    });

    // Initial check for clear buttons
    this.updateClearButtons();

    // Initial load
    this.loadAllLists();
  }

  updateClearButtons() {
    // Find all facets__inputs-wrapper elements (both desktop and mobile/drawer)
    const filterWrappers = document.querySelectorAll('.facets__inputs-wrapper');
    
    filterWrappers.forEach(wrapper => {
      const checkboxes = wrapper.querySelectorAll('[type="checkbox"]');
      const hasChecked = Array.from(checkboxes).some(cb => cb.checked);
      
      let clearButton = wrapper.querySelector('.facets__clear');
      
      if (hasChecked) {
        if (!clearButton) {
          clearButton = document.createElement('div');
          clearButton.className = 'facets__clear';
          clearButton.innerHTML = `
            <button type="button" class="clear-filter button button-secondary">clear selection</button>
          `;
          
          const button = clearButton.querySelector('button');
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.clearFilterGroup(wrapper);
          });
          
          wrapper.insertBefore(clearButton, wrapper.firstChild);
        }
        
        clearButton.classList.add('facets__clear--active');
      } else {
        if (clearButton) {
          clearButton.classList.remove('facets__clear--active');
        }
      }
    });
  }

  clearFilterGroup(wrapper) {
    const checkboxes = wrapper.querySelectorAll('[type="checkbox"]');
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
    
    this.updateClearButtons();
    this.updateAllLists();
  }

  setupTabNavigation() {
    this.navItems.forEach((navItem, index) => {
      navItem.addEventListener('click', () => {
        // Remove active class from all nav items and tabs
        this.navItems.forEach(item => item.classList.remove('collection-tabs__nav-item--active'));
        this.tabs.forEach(tab => tab.classList.remove('is-active-tab'));
        
        // Add active class to clicked nav item and corresponding tab
        navItem.classList.add('collection-tabs__nav-item--active');
        this.tabs[index].classList.add('is-active-tab');
        
        const tabIndex = index + 1;
        
        // Update URL with tab parameter
        const url = new URL(window.location);
        url.searchParams.set('tab', tabIndex);
        window.history.pushState({}, '', url);
        
        // Load content for the newly activated tab
        this.loadTabContent(tabIndex);
      });
    });
  }

  loadAllLists() {
    // Check URL for saved tab
    const urlParams = new URLSearchParams(window.location.search);
    const savedTab = urlParams.get('tab');
    
    if (savedTab) {
      const tabIndex = parseInt(savedTab);
      if (tabIndex > 0 && tabIndex <= this.tabs.length) {
        // Update active classes
        this.navItems.forEach((item, index) => {
          item.classList.toggle('collection-tabs__nav-item--active', index === tabIndex - 1);
        });
        this.tabs.forEach((tab, index) => {
          tab.classList.toggle('is-active-tab', index === tabIndex - 1);
        });
        
        // Load the saved tab
        this.loadTabContent(tabIndex);
        return;
      }
    }
    
    // Default: load first tab
    this.loadTabContent(1);
  }

  loadTabContent(tabIndex, forceReload = false) {
    // Skip if already loaded and not forcing reload
    if (this.loadedTabs.has(tabIndex) && !forceReload) {
      return;
    }
    
    const tabBlocks = this.blocks.filter(block => block.tabIndex === tabIndex);
    const blockResults = [];
    
    // Track loading promises to evaluate all blocks together
    const loadPromises = tabBlocks.map(block => 
      this.loadBlockContent(block, blockResults)
    );
    
    // After all blocks load, check if we should hide empty blocks or show empty message
    Promise.all(loadPromises).then(() => {
      this.handleEmptyBlocks(tabBlocks, blockResults);
      // Mark this tab as loaded
      this.loadedTabs.add(tabIndex);
    });
  }

  updateAllLists() {
    const activeTab = this.querySelector('.collection-tabs__tab.is-active-tab');
    if (!activeTab) return;
    
    const activeTabIndex = Array.from(this.tabs).indexOf(activeTab) + 1;
    
    // Clear loaded tabs cache since filters changed
    this.loadedTabs.clear();
    
    // Force reload of active tab
    this.loadTabContent(activeTabIndex, true);
  }

  getFilterParams() {
    let activeFilters = '';
    let hasActiveFilters = false;
    
    this.filterInputs.forEach(input => {
      if (input.checked) {
        if (hasActiveFilters) {
          activeFilters += '&';
        }
        activeFilters += `${input.name}=${input.value.replace(' ', '+')}`;
        hasActiveFilters = true;
      }
    });
    
    return hasActiveFilters ? activeFilters : '';
  }

  buildFetchUrl(collectionHandle, blockType, isOneBlock = false) {
    let url = `/collections/${collectionHandle}?section_id=main-collection-cupcakes`;
    
    if (isOneBlock) {
      return url;
    }
    
    const filterParams = this.getFilterParams();
    const filterPrefix = filterParams ? '&' : '';
    
    if (filterParams) {
      url += `&${filterParams}`;
    }
    
    // Check if user already applied category filter
    const hasCategoryFilter = filterParams.includes('filter.p.m.custom.category');
    
    if (hasCategoryFilter) {
      // User has category filter - check if it matches block type requirement
      if ((blockType === 1 && !filterParams.includes('Everyday+Classic')) || (blockType === 2 && !filterParams.includes('Daily+Special')) || (blockType === 3 && !filterParams.includes('Seasonal'))) {
        return null;
      }
    } else {
      // No category filter - add default filters based on block type
      if (blockType === 1) {
        // Classic - filter by Classic metafield
        url += `${filterPrefix}&filter.p.m.custom.category=Everyday+Classic`;
      } else if (blockType === 2) {
        // Daily - filter by current day
        url += `${filterPrefix}&filter.p.m.custom.category=Daily+Special`;
      } else if (blockType === 3) {
        // Seasonal - filter by current month
        url += `${filterPrefix}&filter.p.m.custom.category=January+Seasonal&filter.p.m.custom.category=February+Seasonal&filter.p.m.custom.category=March+Seasonal&filter.p.m.custom.category=April+Seasonal&filter.p.m.custom.category=May+Seasonal&filter.p.m.custom.category=June+Seasonal&filter.p.m.custom.category=July+Seasonal&filter.p.m.custom.category=August+Seasonal&filter.p.m.custom.category=September+Seasonal&filter.p.m.custom.category=October+Seasonal&filter.p.m.custom.category=November+Seasonal&filter.p.m.custom.category=December+Seasonal`;
      }
    }
    
    return url;
  }

  loadBlockContent(block, blockResults = null) {
    // Show spinner before loading
    this.showSpinner(block.element);
    
    const url = this.buildFetchUrl(block.collectionHandle, block.blockType, block.isOneBlock);
    
    // If URL is null, it means filter doesn't match block type - show empty
    if (url === null) {
      this.hideSpinner(block.element);
      block.element.innerHTML = '';
      if (block.showMoreContainer) {
        block.showMoreContainer.style.display = 'none';
      }
      
      if (blockResults !== null) {
        blockResults.push({ block, hasProducts: false });
      }
      
      return Promise.resolve(false);
    }
    
    return fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = this.domParser.parseFromString(html, 'text/html');
        const list = doc.querySelector('#in-stock-list')?.innerHTML || '';
        
        // Hide spinner and show content
        this.hideSpinner(block.element);
        
        const hasProducts = this.setLimitedContent(
          block.element,
          list,
          this.maxItemsToShow,
          true,
          block.showMoreContainer,
          block.showMoreBtn,
          block.blockType
        );
        
        // Track result if blockResults array is provided
        if (blockResults !== null) {
          blockResults.push({ block, hasProducts });
        }
        
        return hasProducts;
      })
      .catch(error => {
        console.error('Error loading block content:', error);
        this.hideSpinner(block.element);
        block.element.innerHTML = '';
        if (block.showMoreContainer) {
          block.showMoreContainer.style.display = 'none';
        }
        
        // Track result if blockResults array is provided
        if (blockResults !== null) {
          blockResults.push({ block, hasProducts: false });
        }
        
        return false;
      });
  }

  showSpinner(container) {
    // Show existing spinner
    const spinner = container.querySelector('.our-cupcakes__spinner');
    if (spinner) {
      spinner.style.display = 'flex';
    }
  }

  hideSpinner(container) {
    // Hide spinner
    const spinner = container.querySelector('.our-cupcakes__spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }
  }

  setLimitedContent(container, htmlContent, maxItems, showMoreButton, showMoreContainer, showMoreBtn, blockType = null) {
    if (!htmlContent) {
      container.innerHTML = '';
      if (showMoreButton && showMoreContainer) {
        showMoreContainer.style.display = 'none';
      }
      return false;
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    let items = Array.from(tempDiv.querySelectorAll('.product-grid__item'));

    if (items.length === 0) {
      container.innerHTML = '';
      if (showMoreButton && showMoreContainer) {
        showMoreContainer.style.display = 'none';
      }
      return false;
    }

    // Sort items based on block type
    if (blockType === 3) {
      // Seasonal block: sort by month (starting from current) then by sort number
      items = this.sortProductItemsBySeason(items);
    } else {
      // Other blocks: sort by data-sort-number only
      items = this.sortProductItemsByNumber(items);
    }

    // Remove is-active class from product cards if noAddToCart is true
    if (this.noAddToCart) {
      items.forEach(item => {
        const productCard = item.querySelector('.product-card-wrapper');
        if (productCard) {
          productCard.classList.remove('is-active');
        }
      });
    }

    // If no showMoreContainer, show all items
    const effectiveMaxItems = showMoreContainer ? maxItems : 999;

    if (items.length <= effectiveMaxItems) {
      // Show all items if less than or equal to maxItems
      const visibleItems = items.slice(0, effectiveMaxItems);
      container.innerHTML = '';
      visibleItems.forEach(item => container.appendChild(item));
      
      if (showMoreButton && showMoreContainer) {
        showMoreContainer.style.display = 'none';
      }
    } else {
      // Hide items beyond maxItems
      const visibleItems = items.slice(0, effectiveMaxItems);
      const hiddenItems = items.slice(effectiveMaxItems);

      hiddenItems.forEach(item => {
        item.style.display = 'none';
        item.classList.add('our-cupcakes__hidden-item');
      });
      
      container.innerHTML = '';
      const allItems = [...visibleItems, ...hiddenItems];
      allItems.forEach(item => container.appendChild(item));

      if (showMoreButton && showMoreContainer && showMoreBtn) {
        showMoreContainer.style.display = 'flex';
        showMoreBtn.textContent = `Show More`;
      }
    }
    
    return true;
  }

  handleEmptyBlocks(tabBlocks, blockResults) {
    const hasAnyProducts = blockResults.some(result => result.hasProducts);
    
    if (!hasAnyProducts) {
      blockResults.forEach((result, index) => {
        const blockWrapper = result.block.element.closest('.our-cupcakes__block');
        if (index === 0) {
          this.showEmptyMessage(result.block.element);
          if (blockWrapper) blockWrapper.style.display = '';
        } else {
          if (blockWrapper) blockWrapper.style.display = 'none';
        }
      });
    } else {
      blockResults.forEach(result => {
        const blockWrapper = result.block.element.closest('.our-cupcakes__block');
        if (blockWrapper) {
          blockWrapper.style.display = result.hasProducts ? '' : 'none';
        }
      });
    }
  }

  showEmptyMessage(container) {
    container.innerHTML = `
      <div class="our-cupcakes__empty-message">
        <p>No products found matching your selection.</p>
      </div>
    `;
  }

  sortProductItemsBySeason(items) {
    return items.sort((a, b) => {
      const cardA = a.querySelector('.product-card-wrapper');
      const cardB = b.querySelector('.product-card-wrapper');
      
      const seasonA = cardA?.dataset.sortSeason;
      const seasonB = cardB?.dataset.sortSeason;
      const sortNumberA = cardA?.dataset.sortNumber;
      const sortNumberB = cardB?.dataset.sortNumber;
      
      // Parse months (can be multiple separated by comma)
      const getClosestMonth = (seasonString) => {
        if (!seasonString) return -1;
        
        const months = seasonString.split(',').map(m => m.trim());
        const monthIndices = months.map(month => this.monthNames.indexOf(month)).filter(idx => idx !== -1);
        
        if (monthIndices.length === 0) return -1;
        
        // Find the closest month (smallest relative distance)
        let closestIndex = monthIndices[0];
        let minDistance = (monthIndices[0] - this.currentMonthIndex + 12) % 12;
        
        for (let i = 1; i < monthIndices.length; i++) {
          const distance = (monthIndices[i] - this.currentMonthIndex + 12) % 12;
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = monthIndices[i];
          }
        }
        
        return closestIndex;
      };
      
      const monthIndexA = getClosestMonth(seasonA);
      const monthIndexB = getClosestMonth(seasonB);
      
      // Calculate relative month position from current month
      // Current month = 0, next month = 1, etc.
      const getRelativeMonth = (monthIndex) => {
        if (monthIndex === -1) return 999; // No month goes to end
        const relative = (monthIndex - this.currentMonthIndex + 12) % 12;
        return relative;
      };
      
      const relativeMonthA = getRelativeMonth(monthIndexA);
      const relativeMonthB = getRelativeMonth(monthIndexB);
      
      // First, sort by month (starting from current month)
      if (relativeMonthA !== relativeMonthB) {
        return relativeMonthA - relativeMonthB;
      }
      
      // If same month (or both no month), sort by sort number
      if (sortNumberA && sortNumberB) {
        return parseInt(sortNumberA) - parseInt(sortNumberB);
      }
      
      // Items with sort number come first
      if (sortNumberA && !sortNumberB) {
        return -1;
      }
      
      if (!sortNumberA && sortNumberB) {
        return 1;
      }
      
      return 0;
    });
  }

  sortProductItemsByNumber(items) {
    return items.sort((a, b) => {
      const cardA = a.querySelector('.product-card-wrapper');
      const cardB = b.querySelector('.product-card-wrapper');
      
      const sortNumberA = cardA?.dataset.sortNumber;
      const sortNumberB = cardB?.dataset.sortNumber;
      
      if (sortNumberA && sortNumberB) {
        return parseInt(sortNumberA) - parseInt(sortNumberB);
      }
      
      if (sortNumberA && !sortNumberB) {
        return -1;
      }

      if (!sortNumberA && sortNumberB) {
        return 1;
      }

      return 0;
    });
  }

  showMoreItems(block, showMoreContainer) {
    const hiddenItems = block.querySelectorAll('.our-cupcakes__hidden-item');

    hiddenItems.forEach(item => {
      item.style.display = '';
      item.classList.remove('our-cupcakes__hidden-item');
    });

    if (showMoreContainer) {
      showMoreContainer.style.display = 'none';
    }
  }
}

if (!customElements.get('our-cupcakes')) {
  customElements.define('our-cupcakes', OurCupcakes);
}
